import React from 'react';
import PublicLayout from '@/components/layout/PublicLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, HelpCircle, BookOpen } from 'lucide-react';

export default function ResourcesPage() {
  const blogPosts = [
    { title: 'Understanding Tax Deadlines for 2026', category: 'Tax Filing', date: 'Coming Soon' },
    { title: 'Top 10 Tax Deductions You Might Miss', category: 'Tax Tips', date: 'Coming Soon' },
    { title: 'LLC Formation: Complete Guide', category: 'Business', date: 'Coming Soon' },
    { title: 'Self-Employment Tax Explained', category: 'Tax Filing', date: 'Coming Soon' }
  ];

  const faqs = [
    { question: 'When is the tax filing deadline?', answer: 'The federal tax filing deadline is typically April 15th each year.' },
    { question: 'How much does it cost to file?', answer: 'Start for free and only pay when you file. Pricing varies by return complexity.' },
    { question: 'How long does tax preparation take?', answer: 'Most returns are completed in under 30 minutes with our guided process.' },
    { question: 'Can I get a refund if I overpaid?', answer: 'Yes, any overpayment will be refunded by the IRS after processing your return.' }
  ];

  return (
    <PublicLayout>
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-4">Articles & Guides</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Learn about taxes, LLCs, and managing your business finances
          </p>
        </div>

        {/* Blog Section */}
        <section className="mb-16">
          <div className="flex items-center mb-6">
            <FileText className="h-6 w-6 mr-2 text-blue-600" />
            <h2 className="text-3xl font-bold">Blog & Articles</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {blogPosts.map((post, index) => (
              <Card key={index} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="text-sm text-blue-600 mb-2">{post.category}</div>
                  <CardTitle className="text-xl">{post.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-gray-500">{post.date}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="mb-16">
          <div className="flex items-center mb-6">
            <HelpCircle className="h-6 w-6 mr-2 text-blue-600" />
            <h2 className="text-3xl font-bold">Frequently Asked Questions</h2>
          </div>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <Card key={index}>
                <CardHeader>
                  <CardTitle className="text-lg">{faq.question}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 dark:text-gray-400">{faq.answer}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>

        {/* Guides Section */}
        <section>
          <div className="flex items-center mb-6">
            <BookOpen className="h-6 w-6 mr-2 text-blue-600" />
            <h2 className="text-3xl font-bold">Tax Filing Guides</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            <Card>
              <CardHeader>
                <CardTitle>Individual Tax Guide</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 dark:text-gray-400">Step-by-step guide for filing your personal tax return</p>
                <p className="text-sm text-gray-500 mt-4">Coming Soon</p>
              </CardContent>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle>Business Tax Guide</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 dark:text-gray-400">Complete guide for small business tax compliance</p>
                <p className="text-sm text-gray-500 mt-4">Coming Soon</p>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
    </PublicLayout>
  );
}